import React from "react";
import { Button, Grid, Typography } from "@mui/material";
import { Add, Remove, Clear } from "@mui/icons-material";
import { Division } from "../Icons";

const renderButton = (value, handleClick) => {
  let content;

  switch (value) {
    case "+":
      content = <Add />;
      break;
    case "-":
      content = <Remove />;
      break;
    case "*":
      content = <Clear />;
      break;
    case "/":
      content = <Division />;
      break;
    case "=":
      content = <Typography variant="h5">=</Typography>;
      break;
    case "Function":
      content = <Typography variant="body1" fontStyle="italic">fun</Typography>;
      break;
    default:
      content = <Typography variant="body1">{value}</Typography>;
  }

  return (
    <Grid item xs={3} key={value}>
      <Button
        variant="contained"
        fullWidth
        onClick={() => handleClick(value)}
        sx={{ height: 36, minWidth: 0, px: 0 }}
      >
        {content}
      </Button>
    </Grid>
  );
};

export default renderButton;
